import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        destructive: "border-transparent bg-destructive text-destructive-foreground",
        outline: "text-foreground",
        success: "border-transparent bg-emerald-800 text-emerald-100 dark:bg-zinc-700 dark:text-zinc-300",
        warning: "border-transparent bg-amber-800 text-amber-100 dark:bg-zinc-700 dark:text-zinc-300",
        info: "border-transparent bg-blue-800 text-blue-100 dark:bg-zinc-700 dark:text-zinc-300",
        purple: "border-transparent bg-purple-800 text-purple-100 dark:bg-zinc-700 dark:text-zinc-300",
        pink: "border-transparent bg-pink-800 text-pink-100 dark:bg-zinc-700 dark:text-zinc-300",
        cyan: "border-transparent bg-cyan-800 text-cyan-100 dark:bg-zinc-700 dark:text-zinc-300",
        indigo: "border-transparent bg-indigo-800 text-indigo-100 dark:bg-zinc-700 dark:text-zinc-300",
        teal: "border-transparent bg-teal-800 text-teal-100 dark:bg-zinc-700 dark:text-zinc-300",
        orange: "border-transparent bg-orange-800 text-orange-100 dark:bg-zinc-700 dark:text-zinc-300",
        lime: "border-transparent bg-lime-800 text-lime-100 dark:bg-zinc-700 dark:text-zinc-300",
        rose: "border-transparent bg-rose-800 text-rose-100 dark:bg-zinc-700 dark:text-zinc-300",
        sky: "border-transparent bg-sky-800 text-sky-100 dark:bg-zinc-700 dark:text-zinc-300",
        violet: "border-transparent bg-violet-800 text-violet-100 dark:bg-zinc-700 dark:text-zinc-300",
        fuchsia: "border-transparent bg-fuchsia-800 text-fuchsia-100 dark:bg-zinc-700 dark:text-zinc-300",
      },
    },
    defaultVariants: { variant: "default" },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
